import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { getTopSellingProduct } from "http/dashboard";
import NoDataChart from "pages/Dashboards/NoDataChart";

const TopSellingProducts = ({ startDate, endDate }) => {
  const [customersData, setCustomersData] = useState([])
  const [showStatus, setShowStatus] = useState(true)
  const [type, setType] = useState('Quantity');

  useEffect(() => {
    getTopSellingProduct()
      .then(responseFromApi => {
        if (responseFromApi.status && responseFromApi?.data?.length > 0) {
          setCustomersData(responseFromApi.data)
        } else {
          setShowStatus(false)
          setCustomersData([])
        }
      })
      .catch(error => { })
  }, [])

  const currencyShotern = (amount) => {
    if (amount && !isNaN(amount) && amount != undefined) {
        const formatter = new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            notation: "compact",
            compactDisplay: "long",
        });
        return formatter.format(amount);
    } else return "0.00";
};

  useEffect(() => {
    if (startDate && endDate) {
      getTopSellingProduct({ startDate, endDate, type })
        .then(responseFromApi => {
          if (responseFromApi.status && responseFromApi?.data?.length > 0) {
            setCustomersData(responseFromApi.data)
            setShowStatus(true)
          } else {
            setShowStatus(false)
            setCustomersData([])
          }
        })
        .catch(error => { })
    }
  }, [startDate, endDate]);

  const options = {
    toolbar: {
      show: true,
      tools: {
        download: false,
      },
    },
    chart: {
      type: "bar",
      height: 500,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        endingShape: "rounded",
        barHeight: "50%",
        columnWidth: "40%",
        borderRadius: 4,
        dataLabels: {
          position: "center",
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => {
        if (type !== "Quantity") {
          return currencyShotern(val);
        } else {
          return val;
        }
      },
    },
    colors: [
      function ({ dataPointIndex }) {
        switch (dataPointIndex) {
          case 0:
            return "#EC7063";
          case 1:
            return "#AF7AC5";
          case 2:
            return "#3498DB";
          case 3:
            return "#1ABC9C";
          case 4:
            return "#F1C40F";
          default:
            return "#EC7063";
        }
      },
    ],
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      type: 'categoty',
      title: {
        text: "Products",
      },
      style: {
        fontSize: "16.5px",
        color: "#333",
        background: "transparent",
        maxWidth: 300,
        overflow: "ellipsis",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
      labels: {
        show: true,
        trim: true,
        rotate: 0,
        rotateAlways: false,
        hideOverlappingLabels: false,
      },
      categories: customersData?.map(item => item.productName),
    },
    yaxis: {
      title: {
        text: type,
      },
      labels: {
        formatter: (val) => {
          if (type !== "Quantity") {
            return currencyShotern(val);
          } else {
            return val;
          }
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      enabled: true,
      y: {
        enabled: true,
        formatter: (val) => {
          if (type !== "Quantity") {
            return currencyShotern(val);
          } else {
            return val;
          }
        },
      }
    },
  };

  const series = [
    {
      name: "",
      data: customersData?.map((customer) => parseInt(customer.quantity)),
    },
  ];

  const handleFilterChange = (e) => {
    setType(e.target.value);
    getTopSellingProduct({ startDate, endDate, type: e.target.value })
      .then(responseFromApi => {
        if (responseFromApi.status && responseFromApi?.data?.length > 0) {
          setCustomersData(responseFromApi.data)
          setShowStatus(true)
        } else {
          setShowStatus(false)
          setCustomersData([])
        }
      })
      .catch(error => { })
  };

  return (
    <Card className="h-100">
      {showStatus ? <CardBody>
        <Row className='mb-2 custom-border'>
          <Col lg='6' sm='12' md='6'>
            <h4 className="card-title mb-2">Top Selling Products</h4>
          </Col>
          <Col lg='6' sm='12' md='6' className="mb-2 custom-select-wrapper">
            <select
              className="form-select"
              id="filterOptions"
              value={type}
              onChange={handleFilterChange}
            >
              <option value="Quantity">Quantity</option>
              <option value="Amount">Amount</option>
            </select>
          </Col>
        </Row>
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
          className="mb-2"
        >
        </div>
        <div style={{ maxWidth: "100%" }}>
          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={306}
          />
        </div>
      </CardBody>
        : <NoDataChart title='No Information Found' subtitle="No top selling products are available at the moment" />
      }
    </Card>
  );
};

export default TopSellingProducts;
